import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import lottie from "lottie-web"

import media from "../../../styles/media"

import data from "./lottie.json"

const Container = styled.div`
  position: absolute;
  z-index: 98;
  top: 10px;
  left: 10px;
  right: auto;
  width: 65px;
  height: 65px;
  ${media.tablet`
    display: block;
    left: auto;
    right: 60px;
    width: 175px;
    height: 175px;
  `}
`

const Lottie = styled.div`
  width: 100%;
  height: 100%;
  svg {
    max-width: 100%;
    fill: #fff;
  }
`

const Logo = () => {
  const element = useRef(null)

  useEffect(() => {
    lottie.loadAnimation({
      container: element.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: data,
    })
    return () => {
      lottie.destroy()
    }
  }, [])

  return (
    <Container>
      <Lottie ref={element}></Lottie>
    </Container>
  )
}

export default Logo

/*
  The loader will become the logo
  with a different clas such that it never has to mount / unmount.... yeeeees Luan
*/
